class DropDownSelectionBox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('.select_input_content').addEventListener('click', this.activeList.bind(this));
    this.querySelectorAll('.select_box_item').forEach(item => {
      item.addEventListener('click', this.selectItem.bind(this))
    })
    document.addEventListener('click', this.hideActiveList.bind(this));
  }

  activeList(){
    this.classList.toggle('active')
  }
  hideActiveList(e) {
    if (!this.contains(e.target)) {
      this.classList.remove('active')
    }
  }
  selectItem(e) {
    const selectedItem = e.target;
    this.querySelector('.select_input').value = selectedItem.innerText
    this.querySelectorAll('.select_box_item').forEach(item => {
      item.classList.remove('active')
    })
    selectedItem.classList.add('active')
    this.classList.remove('active')
    this.dispatchEvent(new CustomEvent('change', {
      detail: selectedItem.dataset.value,
      bubbles: false,
      cancelable: true 
    }))
  }
}

customElements.define('drop-down-selection-box', DropDownSelectionBox);

class PagePopUp extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('.pop_close_icon').addEventListener('click', this.popClose.bind(this));
  }

  popClose(){
    this.querySelector('video').pause();
    this.style.display = 'none'
  }

  show() {
    this.style.display = 'flex'
    this.dispatchEvent(new CustomEvent('show', {
      detail: this,
      bubbles: false,
      cancelable: true 
    }))
  }
}

customElements.define('page-pop-up', PagePopUp);